import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { bindActionCreators } from "redux";

const Content = styled.div`
  img {
    width: 140px;
    margin-bottom: 30px;
  }

  h2 {
    margin-bottom: 8px;
  }

  p {
    font-family: Roboto-Light;
    font-size: 12px;
    color: #959595;
    letter-spacing: 0.94px;
    line-height: 23px;
  }
`;

const Next = styled.a`
  background: #ffffff;
  border: 1px solid #34a8f0;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.21);
  border-radius: 3px;
  text-transform: uppercase;
  color: #34a8f0;
  padding: 15px 0;
  text-decoration: none;
  cursor: pointer;
`;

class OBTwo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: false
    };
  }

  stripeAuth = () => {
    window.open(
      process.env.REACT_APP_API_URL + "/users/auth/stripe_connect/",
      "Sign in with Stripe",
      "width=700,height=450"
    );
    var receiveMessage = event => {
      if (event.data.oauth === "success") {
        this.props.changePage();
      } else if (event.data.oauth === "failed") {
        console.log("Authentcation Failed");
      }
    };
    window.addEventListener("message", receiveMessage, false);
  };

  render() {
    return (
      <Content>
        <h2>Billing data</h2>
        <p>Can Narrative access your Stripe data?</p>
        <Next onClick={this.stripeAuth}>Authorize Stripe</Next>
      </Content>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changePage: () => push("/setup/success-metric-question")
    },
    dispatch
  );

const OnBoardingTwo = connect(null, mapDispatchToProps)(OBTwo);

export default OnBoardingTwo;



// WEBPACK FOOTER //
// ./src/containers/onBoard/onboardingTwo.js